import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AutoAffix from 'react-overlays/lib/AutoAffix';
import { compose, contains, defaultTo, filter, isNil, last, not, path } from 'ramda';
import moment from 'moment';

import magic from '../../../../../util/magic';

import Card from '../../../../../components/Card/index';
import Accordion from '../../../../../components/Accordion/index';
import Step from '../../../../../components/Accordion/Step';
import Progress from '../../../../../components/Progress/index';
import {
  CertificateName,
  Ethics,
  Experience,
  FinalSummary,
  EmploymentVerification,
  Module,
  Preferences,
  ProfessionalInfo,
  TakeExam,
} from '../Steps';
import { isNilOrEmpty } from '../../../../../util/redux';
import { createMarkup } from '../../../../../util/helpers';

class PostRegistration extends Component {
  static propTypes = {
    donations: PropTypes.array,
    certification: PropTypes.object,
    memberships: PropTypes.array,
    registration: PropTypes.object,
    user: PropTypes.object,
  };

  state = {
    percentageComplete: 0,
  };

  progressIndicator() {
    const { certification, registration } = this.props;
    const { percentageComplete } = this.state;
    const reviews = defaultTo([], registration.reviews);
    const review = last(reviews);
    const showReview = review && !review.approved;
    const deadline = path(['deadline'], registration);

    return (
      <div className="col-xs-12 col-sm-4">
        <AutoAffix viewportOffsetTop={10} container={this}>
          <div>
            <Card registration>
              <Card.Header registration>{certification.name} Course Registration</Card.Header>
              <Card.Body>
                <Progress percent={percentageComplete} className="mt-4 mb-2" />
                <p>
                  Your registration is <span className="yellow-heading">{percentageComplete}%</span> complete
                </p>
                <span className="font-reset">
                  Deadline: {deadline != null ? moment(deadline).format('MM/DD/YYYY') : 'N/A'}
                </span>
              </Card.Body>
            </Card>
            {showReview && (
              <Card error className="mt-3">
                <Card.Header>Your registration was rejected. Please review these instructions:</Card.Header>
                <Card.Body className="preWrap">
                  <div dangerouslySetInnerHTML={createMarkup(review.message)} />
                </Card.Body>
              </Card>
            )}
          </div>
        </AutoAffix>
      </div>
    );
  }

  render() {
    const { certification, registration } = this.props;
    const modules = defaultTo([], certification.trainings);
    const stepProps = { ...this.props };
    const isLegacyFFC = contains(registration.pathwayTypeId, magic.legacyFFCPathwayIds);
    // TODO: Make less hardcoded
    const isFFCRegistration = certification.id == 7;

    const steps = filter(compose(not, isNil), [
      !isNilOrEmpty(modules) && !isLegacyFFC ? null : { as: TakeExam, name: 'take_exam', title: 'Take Exam' },
      isLegacyFFC ? null : { as: Experience, name: 'experience', title: 'Experience' },
      isFFCRegistration || registration.militarySpouse
        ? null
        : { as: EmploymentVerification, name: 'employment_verification', title: 'Employment Verification' },
      { as: CertificateName, name: 'certificate_name', title: 'Certificate Name' },
      !isNilOrEmpty(modules) || isLegacyFFC || registration.militarySpouse
        ? null
        : { as: ProfessionalInfo, name: 'professional_info', title: 'Professional Info' },
      { as: Preferences, name: 'preferences', title: 'Preferences' },
      { as: Ethics, name: 'code_of_ethics', title: 'Code Of Ethics' },
      { as: FinalSummary, name: 'final_summary', title: 'Summary' },
    ]);

    if (!isNilOrEmpty(modules) && !isLegacyFFC) {
      steps.unshift(
        ...modules.map((module) => ({
          as: Module,
          name: `${magic.moduleStepPrefix}${module.categoryId}`,
          title: module.name,
          module: module,
        })),
      );
    }

    return (
      <div className="row">
        {this.progressIndicator()}
        <div className="col-xs-12 col-sm-8">
          <Accordion
            step={registration.step}
            onPercentageChanged={(percent) => this.setState({ percentageComplete: percent })}
          >
            {steps.map((step) => (
              <Step key={step.name} {...step} {...stepProps} />
            ))}
          </Accordion>
        </div>
      </div>
    );
  }
}

export default PostRegistration;
